//src/app/features/dashboard/client/ClientDashboard.tsx
import { ViewAnnouncements } from 'app/routes/AnnouncementsRoutes';
import { ViewUpcomingDates } from 'app/routes/UpcomingDatesRoutes';

import Spinner from 'Components/Spinner';
import { useCallback, useState } from 'react';
import ClientTaxReturnStats from '../ClientTaxReturnStats';
import VideosSection from '../VideosSection';

const ClientDashboard = () => {
  const [isReady, setIsReady] = useState({
    stats: false,
    announcemnents: false,
    events: false,
  });

  const isLoading = Object.values(isReady).some((v) => !v);

  const handleUpcomingDatesLoad = useCallback(() => {
    setIsReady((isReady) => ({ ...isReady, events: true }));
  }, []);

  const handleAnnouncementsLoad = useCallback(() => {
    setIsReady((isReady) => ({ ...isReady, announcemnents: true }));
  }, []);

  const handleStatsLoad = useCallback(() => {
    setIsReady((isReady) => ({ ...isReady, stats: true }));
  }, []);

  return (
    <>
      {isLoading && <Spinner />}
      <div
        className={`${
          isLoading ? 'scale-0' : ' scale-100'
        } transform space-y-4 xl:space-y-0 xl:grid xl:grid-cols-8 grid-flow-col-dense xl:p-0 p-2  xl:grid-rows-5  h-full  overflow-auto gap-2  bg-gray-400 animate-fade`}
        hidden={isLoading}
      >
        <div className="max-h-[400px] h-[400px] xl:h-full xl:col-span-2 xl:row-span-5 xl:max-h-full w-full overflow-auto bg-white">
          <ViewUpcomingDates onLoad={handleUpcomingDatesLoad} />
        </div>

        <div className="max-h-[400px] xl:col-span-3 xl:row-span-3 xl:h-full xl:max-h-full w-full overflow-auto bg-white">
          <ViewAnnouncements onLoad={handleAnnouncementsLoad} />
        </div>

        <div className=" xl:col-span-3 xl:row-span-2 bg-white">
          <VideosSection />
        </div>

        <div className="w-full h-full xl:col-span-3 xl:row-span-5 bg-white">
          <ClientTaxReturnStats onLoad={handleStatsLoad} />
        </div>
      </div>
    </>
  );
};

export default ClientDashboard;
